import { Link } from "react-router-dom";
import { ArrowLeft, Palette } from "lucide-react";
import { Button } from "@eduviaos/ui-kit";
import { getCurrentTenant } from "@eduviaos/shared";
import { BrandingPanel } from "@/components/branding/BrandingPanel";

/**
 * Phase F2b — IA self-serve branding editor (Settings surface).
 *
 * The standing counterpart to the first-run "Branding" step: an
 * institution admin can revisit their logo, favicon and colours anytime
 * from Settings → Branding. Writes go through the tenant-scoped
 * `/me/branding` API (keyed on the admin's JWT, never a slug), and
 * saving repaints the live admin shell + is served to the learners'
 * portal via the public branding API.
 */
export function SettingsBrandingPage() {
  const slug = getCurrentTenant().slug ?? null;

  return (
    <div className="mx-auto max-w-5xl py-10">
      <Button variant="ghost" size="sm" asChild className="mb-6">
        <Link to="/settings">
          <ArrowLeft aria-hidden="true" className="size-4" />
          Back to settings
        </Link>
      </Button>

      <div className="mb-8 flex items-start gap-3">
        <span
          aria-hidden="true"
          className="bg-primary/10 text-primary grid size-11 shrink-0 place-items-center rounded-lg"
        >
          <Palette className="size-5" />
        </span>
        <div>
          <h1 className="text-3xl font-semibold tracking-tight">Branding</h1>
          <p className="text-muted-foreground mt-2 max-w-2xl text-sm leading-relaxed">
            Your logo, favicon and brand colours. Changes apply across your admin portal and your
            learners&apos; / students&apos; portal as soon as you save.
          </p>
        </div>
      </div>

      {slug ? (
        <BrandingPanel slug={slug} />
      ) : (
        <p className="text-muted-foreground text-sm">
          Couldn&apos;t resolve your workspace. Refresh and try again.
        </p>
      )}
    </div>
  );
}
